import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { d as defineCustomElement$1 } from './p-Da2lAZSv.js';

const componentHeaderCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;background-color:var(--jw-theme-surface-level0-bg-color);border-bottom:1px solid var(--jw-theme-surface-border-border-color);box-sizing:border-box;color:var(--jw-theme-surface-text-description-color);display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;font-weight:600;gap:1rem;letter-spacing:-.0004em;line-height:normal;line-height:1.25rem;padding:1rem}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}";

const WuiComponentHeader = /*@__PURE__*/ proxyCustomElement(class WuiComponentHeader extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        return (h(Host, { key: 'b67d016a01c885e23aac987da59887f13455b92f' }, this.icon && h("wui-icon", { key: '1b1391e46080ef8adbdd66b2eb3cb53324eab2f7', name: this.icon, size: "md" }), this.label && h("span", { key: '24f39b21c60be4f1e20536c24d123420ecb576d4' }, this.label), h("slot", { key: '491b2e1568bdf3197dedaa2609f82375ad4ac81e' })));
    }
    static get style() { return componentHeaderCss; }
}, [257, "wui-component-header", {
        "label": [1],
        "icon": [1]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-component-header", "wui-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-component-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiComponentHeader);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiComponentHeader as W, defineCustomElement as d };
